export const TYPE_LABELS = {
  phone: "Phone Call",
  text: "Text / SMS",
  email: "Email",
  in_person: "In-Person Meeting",
  letter: "Letter / Mail",
  other: "Other",
};

export const DIRECTION_LABELS = {
  incoming: "Incoming",
  outgoing: "Outgoing",
  task_only: "Task",
  reminder: "Reminder",
};

export const VISIBILITY_LABELS = {
  only_me: "Only Me",
  private: "Private (+ admins)",
  clinical: "Clinical Only",
  all: "All Staff",
};

export const ROLE_OPTIONS = [
  { value: "parent", label: "Parent / Guardian" },
  { value: "student", label: "Student" },
  { value: "district", label: "District" },
  { value: "community", label: "Community Partner" },
  { value: "other", label: "Other" },
];
